import { InteriorModel } from '../types/interior'

export const interiorModels: InteriorModel[] = [
  {
    id: 'joshua',
    name: 'JOSHUA',
    sqft: 662,
    beds: 1,
    baths: 1,
    price: 200000,
    location: 'Edmonton',
    description: 'Style and convenience',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1480074568708-e7b720bb3f09?auto=format&fit=crop&w=800&q=80',
    features: ['Compact living', 'Modern design', 'Low maintenance'],
    houseType: 'Townhome',
    garageType: 'No Garage',
    community: 'Edmonton',
  },
  {
    id: 'blatchford-ascent',
    name: 'BLATCHFORD ASCENT',
    sqft: 1532,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Double garage',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
    features: ['Double garage', 'Modern exterior', 'Premium finishes'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Edmonton',
  },
  {
    id: 'pisa-24',
    name: 'PISA 24',
    sqft: 2094,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Open-concept main floor',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=800&q=80',
    features: ['Open concept', 'Spacious main floor', 'Modern kitchen'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Edmonton',
  },
  {
    id: 'petra-24',
    name: 'PETRA 24',
    sqft: 2016,
    beds: 3,
    baths: 2.5,
    price: 700000,
    location: 'Edmonton',
    description: 'Open Flex Room',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
    features: ['Flex room', 'Open layout', 'Premium upgrades'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Edmonton',
  },
  {
    id: 'terra-22',
    name: 'TERRA 22',
    sqft: 1824,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Open-to-below design',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=80',
    features: ['Open to below', 'Dramatic ceilings', 'Bright interior'],
    houseType: 'Laned Home',
    garageType: 'Double Detached',
    community: 'Edmonton',
  },
  {
    id: 'canyon-g24',
    name: 'CANYON G24',
    sqft: 1840,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Double Detached Car',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?auto=format&fit=crop&w=800&q=80',
    features: ['Double detached garage', 'Spacious layout', 'Family friendly'],
    houseType: 'Laned Home',
    garageType: 'Double Detached',
    community: 'Edmonton',
  },
  {
    id: 'eiffel-24',
    name: 'EIFFEL 24',
    sqft: 2076,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Spacious bonus room',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?auto=format&fit=crop&w=800&q=80',
    features: ['Bonus room', 'Spacious layout', 'Modern finishes'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Edmonton',
  },
  {
    id: 'eiffel-26',
    name: 'EIFFEL 26',
    sqft: 2215,
    beds: 3,
    baths: 2.5,
    price: 800000,
    location: 'Calgary',
    description: 'Oversized Nook',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=800&q=80',
    features: ['Oversized nook', 'Premium upgrades', 'Elegant design'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Calgary',
  },
  {
    id: 'everest-26',
    name: 'EVEREST 26',
    sqft: 2327,
    beds: 3,
    baths: 2.5,
    price: 700000,
    location: 'Edmonton',
    description: 'Thoughtfully crafted layout',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1598228723793-52759bba239c?auto=format&fit=crop&w=800&q=80',
    features: ['Crafted layout', 'Generous rooms', 'Quality finishes'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Edmonton',
  },
  {
    id: 'everest-28',
    name: 'EVEREST 28',
    sqft: 2531,
    beds: 4,
    baths: 3,
    price: 800000,
    location: 'Calgary',
    description: 'Perfect for entertaining and everyday living',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=800&q=80',
    features: ['Entertainment ready', '4 bedrooms', 'Spacious living'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Calgary',
  },
  {
    id: 'fairmont-18',
    name: 'FAIRMONT 18',
    sqft: 1576,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'Open-concept layout',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1592595896551-12b371d546d5?auto=format&fit=crop&w=800&q=80',
    features: ['Open concept', 'Efficient design', 'Modern kitchen'],
    houseType: 'Laned Home',
    garageType: 'Double Detached',
    community: 'Edmonton',
  },
  {
    id: 'fairmont-20',
    name: 'FAIRMONT 20',
    sqft: 1624,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'Open-concept layout',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80',
    features: ['Open concept', 'Bright spaces', 'Family friendly'],
    houseType: 'Laned Home',
    garageType: 'Double Detached',
    community: 'Edmonton',
  },
  {
    id: 'fairmont-g20',
    name: 'FAIRMONT G20',
    sqft: 1576,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'Cozy bonus room',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?auto=format&fit=crop&w=800&q=80',
    features: ['Bonus room', 'Front garage', 'Cozy design'],
    houseType: 'Front Garage Home',
    garageType: 'Single Attached',
    community: 'Edmonton',
  },
  {
    id: 'fort-20',
    name: 'FORT 20',
    sqft: 1669,
    beds: 4,
    baths: 3,
    price: 500000,
    location: 'Calgary',
    description: '3 spacious bedrooms with an option for a 4th',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=800&q=80',
    features: ['4 bedrooms', 'Flexible layout', 'Great value'],
    houseType: 'Laned Home',
    garageType: 'Double Detached',
    community: 'Calgary',
  },
  {
    id: 'fort-g20',
    name: 'FORT G20',
    sqft: 1673,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'L-shaped kitchen',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
    features: ['L-shaped kitchen', 'Front garage', 'Functional layout'],
    houseType: 'Front Garage Home',
    garageType: 'Single Attached',
    community: 'Edmonton',
  },
  {
    id: 'fort-g22',
    name: 'FORT G22',
    sqft: 1725,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'L-shaped kitchen',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=800&q=80',
    features: ['L-shaped kitchen', 'Larger footprint', 'Modern design'],
    houseType: 'Front Garage Home',
    garageType: 'Single Attached',
    community: 'Edmonton',
  },
  {
    id: 'fuji-26',
    name: 'FUJI 26',
    sqft: 2206,
    beds: 3,
    baths: 2.5,
    price: 700000,
    location: 'Calgary',
    description: 'Functionality meets innovation',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=80',
    features: ['Innovative design', 'Functional spaces', 'Premium finishes'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Calgary',
  },
  {
    id: 'lotus-22',
    name: 'LOTUS 22',
    sqft: 1824,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Open-concept main floor',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80',
    features: ['Open concept', 'Main floor living', 'Bright interior'],
    houseType: 'Laned Home',
    garageType: 'Double Detached',
    community: 'Edmonton',
  },
  {
    id: 'louvre-22',
    name: 'LOUVRE 22',
    sqft: 1649,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'Functionality with modern style',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?auto=format&fit=crop&w=800&q=80',
    features: ['Modern style', 'Functional layout', 'Quality finishes'],
    houseType: 'Laned Home',
    garageType: 'Double Detached',
    community: 'Edmonton',
  },
  {
    id: 'nile-24',
    name: 'NILE 24',
    sqft: 2003,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Perfect balance of comfort and elegance',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?auto=format&fit=crop&w=800&q=80',
    features: ['Comfort and elegance', 'Balanced design', 'Premium upgrades'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Edmonton',
  },
  {
    id: 'opera-24',
    name: 'OPERA 24',
    sqft: 1801,
    beds: 3,
    baths: 2.5,
    price: 600000,
    location: 'Edmonton',
    description: 'Open-concept layout',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    features: ['Open concept', 'Spacious rooms', 'Modern kitchen'],
    houseType: 'Front Garage Home',
    garageType: 'Double Attached',
    community: 'Edmonton',
  },
  {
    id: 'valley-g22',
    name: 'VALLEY G22',
    sqft: 1624,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Calgary',
    description: 'Open-concept layout',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=800&q=80',
    features: ['Open concept', 'Front garage', 'Efficient design'],
    houseType: 'Front Garage Home',
    garageType: 'Single Attached',
    community: 'Calgary',
  },
  {
    id: 'valley-g24',
    name: 'VALLEY G24',
    sqft: 1700,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'Open-concept layout',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1592595896551-12b371d546d5?auto=format&fit=crop&w=800&q=80',
    features: ['Open concept', 'Larger layout', 'Family friendly'],
    houseType: 'Front Garage Home',
    garageType: 'Single Attached',
    community: 'Edmonton',
  },
  {
    id: 'walterdale-20',
    name: 'WALTERDALE 20',
    sqft: 1398,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'Low-maintenance lifestyle',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80',
    features: ['Low maintenance', 'Compact design', 'Modern living'],
    houseType: 'Duplex',
    garageType: 'Single Attached',
    community: 'Edmonton',
  },
  {
    id: 'walterdale-g22',
    name: 'WALTERDALE G22',
    sqft: 1409,
    beds: 3,
    baths: 2.5,
    price: 500000,
    location: 'Edmonton',
    description: 'A beautifully designed duplex home',
    thumbnailUrl:
      'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=800&q=80',
    features: ['Duplex design', 'Beautiful finishes', 'Great value'],
    houseType: 'Duplex',
    garageType: 'Single Attached',
    community: 'Edmonton',
  },
]
